<!-- <div class="product">
  <div class="description">
    <div class="product-name">{{ userStory.title }}</div>
  </div>
  <div class="category-name">{{ userStory.description }}</div>
</div> -->
<kendo-expansionpanel id="" [(expanded)]="expandedState" style="width: 100%;" (expand)="onExpand()"
  (collapse)="onCollapse()">
  <ng-template kendoExpansionPanelTitleDirective>
    <div class="header-content">
      @if(!expandedState){
      @if(iconList){
      <span style="margin-right: 5px;">
        <fa-icon class="fa-solid fa-duotone {{selectTypeIconClass}} " [icon]="iconList!"></fa-icon>
      </span>
      }
      <span>
        {{title!.value}}
      </span>
      } @else {
      <div class="container-fluid">
        <form #ngF="ngForm" [formGroup]="formHeader" #pForm action="#" style="width: 100%;">
          <div class="AutosizeTextArea_container">
            <kendo-textarea class="AutosizeTextArea" formControlName="title" (valueChange)="onChange($event)"
              appAutoFocus></kendo-textarea>
          </div>
          @if(titleIsDirty){
          <div class="d-grid d-md-flex mt-2 justify-content-md-end">
            <button type="button" class="btn btn-outline-secondary btn-sm me-md-2" (click)="cancelTitleEdit()">Cancel
            </button>
            <button type="button" class="btn btn-primary btn-sm me-md-2" (click)="saveTitleChanges()"
              [disabled]="formHeader.invalid">Update
            </button>
          </div>
          }
        </form>
      </div>
      }
    </div>
  </ng-template>
  <!-- {{storyStatuses | json}} -->
  <kendo-buttongroup selection="single">
    <button kendoButton title="Copy this story's link to your clipboard" (click)="copyLink(userStory)">
      <fa-icon class="fa-solid fa-duotone " [icon]="['fad', 'link']"></fa-icon>
    </button>
    <button kendoButton title="Copy this story's ID to your clipboard" (click)="copyStoryID(userStory.id!)">
      ID {{userStory.id}}
    </button>
  </kendo-buttongroup>
  <kendo-buttongroup selection="single">
  </kendo-buttongroup>

  <form #ngF="ngForm" class="k-form-inline" [formGroup]="form" #pForm action="#" style="width: 100%;">
    <div class="border-0 p-3 tile-css">

      <!-- @if(showProjects) { -->
      <div class="k-form-field">
        <label for="project_name" class="form-label col-3">Project</label>
        <div class="col-8">
          <div class="component-container">
            <kendo-formfield showHints="always">
              <!-- <div>
                project id: {{project_id_value}}<br>
                show projects: {{showProjects}}<br>
                fIsDirty: {{fIsDirty}}
              </div> -->
              <div class="k-form-field-wrap">
                <kendo-dropdownlist [readonly]="!showProjects" class="ddl" #project_name id="project_name"
                  [data]="projects" formControlName="project_id" textField="project_name" valueField="id"
                  [value]="selectedProjectId" [valuePrimitive]="true" (selectionChange)="projectValueChange($event)"
                  [defaultItem]="defaultProjectItem">
                </kendo-dropdownlist>
                <div *ngIf="project_id?.invalid" class="alert alert-danger">
                  <div *ngIf="project_id?.errors?.['required']">Select a project.</div>
                </div>
              </div>
            </kendo-formfield>
          </div>
        </div>
      </div>
      <!-- } -->

      <div class="k-form-field">
        <label class="form-label col-3">Story Type</label>
        <div class="col-8">
          <div class="component-container">
            <kendo-formfield showHints="always">
              <!-- <div>
                user story id: {{user_story_type_id_value}}<br>
                user status: {{user_story_status_description_value}}
              </div> -->
              <div class="k-form-field-wrap">
                <kendo-dropdownlist #storyType formControlName="user_story_type_id" [data]="storyTypes"
                  textField="user_story_type_description" valueField="id" [value]="selectedType" [valuePrimitive]="true"
                  (selectionChange)="selectionChange($event)" [defaultItem]="defaultStoryTypeItem">
                  <ng-template kendoDropDownListItemTemplate let-dataItem>
                    @if(dataItem.iconClass) {
                    <fa-icon class="fa-solid fa-duotone {{dataItem?.iconClass}}"
                      [icon]="['fad', dataItem?.icon]"></fa-icon>
                    }
                    {{ dataItem.user_story_type_description }}
                  </ng-template>
                  <ng-template kendoDropDownListValueTemplate let-dataItem>
                    @if(dataItem) {
                    @if(dataItem.iconClass){
                    <fa-icon class="fa-solid fa-duotone {{dataItem.iconClass}}"
                      [icon]="['fad', dataItem.icon]"></fa-icon>
                    }
                    {{ dataItem.user_story_type_description }}
                    }
                  </ng-template>
                </kendo-dropdownlist>
              </div>

            </kendo-formfield>
            <div *ngIf="user_story_type_id?.invalid" class="alert alert-danger">
              <div *ngIf="user_story_type_id?.errors?.['required']">Story type is required.</div>
            </div>

          </div>
        </div>
      </div>

      <div class="k-form-field">
        <label for="state" class="form-label col-3">Status</label>
        <div class="col-4">
          <div class="component-container">
            <kendo-formfield showHints="always">
              <!-- <div>
                user status id: {{user_story_status_id_value}}<br>
                user status: {{user_story_status_description_value}}
              </div> -->
              <kendo-dropdownlist #state formControlName="user_story_status_id" [data]="storyStatuses"
                [defaultItem]="{ text: 'Select state', value: null }" textField="user_story_status_description"
                valueField="id" [value]="selectedStatus" [valuePrimitive]="true"
                (selectionChange)="selectionStatusChange($event)">
              </kendo-dropdownlist>
            </kendo-formfield>
            <div *ngIf="user_story_status_id?.invalid" class="alert alert-danger">
              <div *ngIf="user_story_status_id?.errors?.['required']">Story status is required.</div>
            </div>
          </div>
        </div>
        <div class="offset-1 col-4">
          <casi-status-button [storyStatus]="selectedStoryStatus"
            (onChange)="onStatusButtonChange($event)"></casi-status-button>
        </div>
      </div>

      <div class="k-form-field">
        <label class="form-label col-3">Project Labels</label>
        <div class="col-8">
          <div class="component-container">
            <kendo-formfield showHints="always">
              <div class="k-form-field-wrap">
                <kendo-dropdownlist class="ddl" #projectLabel formControlName="project_label_id"
                                    [data]="projectLabels" textField="project_label_description" valueField="id" [valuePrimitive]="true"
                                    (selectionChange)="selectionEstimateChange($event)" [defaultItem]="defaultDropdownItem">
                </kendo-dropdownlist>
              </div>

            </kendo-formfield>

          </div>
        </div>
      </div>

      <div class="k-form-field">
        <label class="form-label col-3">Priority</label>
        <div class="col-8">
          <div class="component-container">
            <kendo-formfield showHints="always">
              <!-- <div>
                user priority id: {{user_story_priority_id_value}}<br>
                user priority: {{user_story_priority_description_value}}
              </div> -->
              <div class="k-form-field-wrap">
                <kendo-dropdownlist #storyPriority id="storyPriority" formControlName="user_story_priority_id"
                  [data]="storyPriorities" textField="user_story_priority_description" valueField="id"
                  [value]="selectedPriority" [valuePrimitive]="true" (selectionChange)="selectionPriorityChange($event)"
                  [defaultItem]="defaultDropdownItem">
                </kendo-dropdownlist>
              </div>

            </kendo-formfield>
            <div *ngIf="user_story_priority_id?.invalid" class="alert alert-danger">
              <div *ngIf="user_story_priority_id?.errors?.['required']">Story priority is required.</div>
            </div>

          </div>
        </div>
      </div>

      <div class="k-form-field">
        <label class="form-label col-3">Estimate</label>
        <div class="col-8">
          <div class="component-container">
            <kendo-formfield showHints="always">
              <!-- <div>
                user estimate id: {{user_story_estimate_id_value}}<br>
                user estimate: {{user_story_estimate_description_value}}
              </div> -->
              <div class="k-form-field-wrap">
                <kendo-dropdownlist #estimate formControlName="user_story_estimate_id" [data]="storyEstimates"
                  textField="user_story_estimate_description" valueField="id" [value]="selectedPriority"
                  [valuePrimitive]="true" (selectionChange)="selectionEstimateChange($event)"
                  [defaultItem]="defaultDropdownItem">
                </kendo-dropdownlist>
              </div>

            </kendo-formfield>
            <div *ngIf="user_story_estimate_id?.invalid" class="alert alert-danger">
              <div *ngIf="user_story_estimate_id?.errors?.['required']">Story estimate is required.</div>
            </div>

          </div>
        </div>
      </div>

      <div class="k-form-field">
        <label class="form-label col-3">Requester</label>
        <div class="col-8">
          <div class="component-container">
            <kendo-formfield showHints="always">
              <!-- <div>
                user requester id: {{requested_by_user_id_value}}<br>
                user requester: {{requested_by_user_value}}
              </div> -->

              <div class="k-form-field-wrap">
                <kendo-dropdownlist #requester formControlName="requested_by_user_id" [data]="users"
                  textField="fullName" valueField="id" [value]="selectedRequester" [valuePrimitive]="true"
                  (selectionChange)="selectionRequesterChange($event)">
                  <ng-template kendoDropDownListItemTemplate let-dataItem>
                    <span class="template">{{ dataItem?.initials }}</span> {{ dataItem?.fullName }}
                  </ng-template>
                  <ng-template kendoDropDownListValueTemplate let-dataItem>
                    <span class="template">{{ dataItem?.initials }}</span> {{ dataItem?.fullName }}
                  </ng-template>
                </kendo-dropdownlist>
              </div>

            </kendo-formfield>
            <div *ngIf="requested_by_user_id?.invalid" class="alert alert-danger">
              <div *ngIf="requested_by_user_id?.errors?.['required']">Requester is required.</div>
            </div>

          </div>
        </div>
      </div>

      <div class="k-form-field">
        <label class="form-label col-3">Owners</label>
        <div class="col-8">
          <div class="component-container">
            <kendo-formfield showHints="always">
              <!-- <p>{{owned_by_user_ids_value | json}}</p> -->
              <!-- <p>{{modUsers | json}}</p> -->
              <kendo-multiselect #owners [data]="modUsers" textField="fullName" valueField="user_id"
                formControlName="owned_by_user_ids" [valuePrimitive]="true">
                <ng-template kendoMultiSelectItemTemplate let-dataItem>
                  <span class="template">{{ dataItem.initials }}</span> {{ dataItem.fullName }}
                </ng-template>
                <ng-template kendoMultiSelectTagTemplate let-dataItem>
                  <span class="templateOwners">{{ dataItem.initials }}</span> {{ dataItem.fullName }}
                </ng-template>
              </kendo-multiselect>

              <!-- <kendo-multiselect style="min-width: 200px;" [data]="modUsers" textField="fullName" valueField="user_id"
                  formControlName="owned_by_users_json" [(ngModel)]="selectedOwners" [valuePrimitive]="false"
                  (valueChange)="onValueChange($event)" (removeTag)="onRemoveTag($event)">
                <ng-template kendoMultiSelectItemTemplate let-dataItem>
                  <span class="template">{{ dataItem.initials }}</span> {{ dataItem.fullName }}
                </ng-template>
                <ng-template kendoMultiSelectTagTemplate let-dataItem>
                  <span class="templateOwners">{{ dataItem.initials }}</span> {{ dataItem.fullName }}
                </ng-template>
              </kendo-multiselect> -->

              <!-- <kendo-multiselect [data]="users" textField="fullName" valueField="id" [valuePrimitive]="true"
                formControlName="owners" [(ngModel)]="selectedOwners">
                <ng-template kendoMultiSelectItemTemplate let-dataItem>
                  <span class="template">{{ dataItem.initials }}</span> {{ dataItem.fullName }}
                </ng-template>
                <ng-template kendoMultiSelectTagTemplate let-dataItem>
                  <span class="templateOwners">{{ dataItem.initials }}</span> {{ dataItem.fullName }}
                </ng-template>
              </kendo-multiselect> -->
            </kendo-formfield>
            <div *ngIf="owned_by_user_ids?.invalid" class="alert alert-danger">
              <div *ngIf="owned_by_user_ids?.errors?.['required']">Owner is required.</div>
            </div>
          </div>
        </div>
      </div>

    </div>
    @if(fIsDirty) {
    <div class="d-grid d-md-flex mt-2 justify-content-md-end">
      <button type="button" class="btn btn-outline-secondary btn-sm me-md-2" (click)="cancelMainFormEdit()">Cancel
      </button>
      <button type="button" class="btn btn-primary btn-sm me-md-2" (click)="saveMainForm()"
        [disabled]="form.invalid">Save Changes
      </button>
    </div>
    }

  </form>

  <div class="row g-1 row-padding-top">
    <label for="description" class="form-label " (click)="inlineEditClicked('description')">Description <span
        *ngIf="readonlyDescription"> <button type="button" class="btn float-end"
          (click)="inlineEditClicked('description')"><fa-icon icon="edit"></fa-icon></button>
      </span>
    </label>
    @if(readonlyDescription){

    <!-- <div class="inline-edit-area" [innerHTML]="userStory.description | tokenSwap | safeHtml"
      (click)="inlineEditClicked('description')">
    </div> -->
    <div class="inline-edit-area" [innerHTML]="userStory.description | tokenSwap | imgZoom | safeHtml">
    </div>
    <div>
    </div>
    } @else {

    <form #ngF="ngForm" class="k-form-inline" [formGroup]="formDescription">
      <div #keDescription>
        <!-- <kendo-editor formControlName="description"></kendo-editor> -->
        <!-- <casi-kendo-editor [value]="edvalue"  [recordId]="userStory.id!" (onValueChange)="valueChange($event)"
          (onImageUpdated)="onImageLoaded($event)" [tableName]="'user_story'"></casi-kendo-editor> -->
        <casi-kendo-editor [value]="userStory.description | tokenSwap" [recordId]="userStory.id!"
          (onValueChange)="valueChange($event)" (onImageUpdated)="onImageLoaded($event)"
          [tableName]="'user_story'"></casi-kendo-editor>
      </div>
      <div class="d-grid d-md-flex mt-2 justify-content-md-end">
        <button type="button" class="btn btn-outline-secondary btn-sm me-md-2"
          (click)="cancelInlineEdit('description')">Cancel
        </button>
        <button type="button" class="btn btn-primary btn-sm me-md-2" (click)="saveInlineChanges('description')"
          [disabled]="formDescription.invalid">Update
        </button>
      </div>

    </form>

    }
  </div>
  <hr>
  <kendo-expansionpanel id="" [expanded]="false" style="width: 100%; border-color: grey;">
    <ng-template kendoExpansionPanelTitleDirective>
      <div class="header-content" style="color: unset;">
        Historic Files ({{historicFiles.length}})
      </div>
    </ng-template>
    <div *ngFor="let file of historicFiles" style="margin: 10px 0px;">
      <a href="{{file.url}}" target="_blank">{{file.filename}}</a>
    </div>
  </kendo-expansionpanel>

  <kendo-listview class="flex-fill" [data]="listView!" containerClass="k-d-flex k-flex-col k-flex-nowrap">
    <ng-template kendoListViewHeaderTemplate>
      <div class="header">
        <div class="title">
          Comment
        </div>
        <!-- <div class="title-sort center"> -->
        <div class="sort-wrapper">
          <kendo-label style="width: 80px;">
            Sort by
          </kendo-label>
          <kendo-dropdownlist [data]="sortOptions" [(ngModel)]="selectedSort" fillMode="flat"
            (selectionChange)="sortSelectionChange($event)"></kendo-dropdownlist>
        </div>
      </div>
    </ng-template>
    <ng-template kendoListViewItemTemplate let-dataItem="dataItem">
      <casi-user-story-comment class="current-item" [currentComment]="dataItem" [users]="users"
        (onDeleteComment)="handleCommentDelete($event)" (onSaveComment)="handleCommentSave($event)">
      </casi-user-story-comment>
    </ng-template>
  </kendo-listview>
  <hr>
  <form #ngF="ngForm" class="k-form-inline" [formGroup]="formComment" #pCommentForm>

    <div class="row g-1 row-padding-top">
      <label for="toPost" class="form-label ">Add Comment</label>
      <!-- <kendo-editor formControlName="toPost"></kendo-editor> -->
      <casi-kendo-editor [value]="comvalue" [recordId]="userStory.id!" (onValueChange)="commentValueChange($event)"
        (onImageUpdated)="onImageLoaded($event)" [tableName]="'user_story'"></casi-kendo-editor>
    </div>

    <div class="d-grid d-md-flex mt-2 justify-content-md-end">
      <button type="button" class="btn btn-primary btn-sm me-md-2" (click)="onPost()"
        [disabled]="formComment.invalid">Post
        comment
      </button>
    </div>

  </form>

</kendo-expansionpanel>

@if(showCloseButton) {
<div class="d-grid d-md-flex mt-2 justify-content-md-end">
  <button type="button" class="btn btn-primary" (click)="onClose()">Close</button>
</div>
}


<div kendoDialogContainer></div>

<div id="MaxImg"></div>
